module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/fv-voice-sp-cc4ea10987a605fc055f31df1ba2d084.png";